import React from 'react';
import { useRoutes } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { $authLoading } from './store/auth';
import { $activeTenantId } from './store/tenantContext';
// import Navigation from './components/Navigation';
import Sidebar from './components/Sidebar';
import LoadingScreen from './components/LoadingScreen';
import routes from './routes';
import './App.css';
function App() {
  const routing = useRoutes(routes);
  const [isLoading, activeTenantId] = useUnit([$authLoading, $activeTenantId]);

  return (
    <div className="app">
      <Sidebar />
      <div className="app-stage">
        {/* <Navigation /> */}
        
        <main className="main-content">
          <React.Fragment key={activeTenantId || 'no-tenant'}>
            {isLoading ? <LoadingScreen /> : routing}
          </React.Fragment>
        </main>
      </div>
    </div>
  );
}

export default App;
